import moment from 'moment';

export const getday = (dob: any) => {
    let day;
    if (dob !== undefined && dob !== null && dob !== "") {
        day = moment(dob).format('dddd');
    }
    return day;
}